import axios from 'axios'
// import store from "../router/index"
import store from '@/store'
import domMessage from './messageOnce'
const messageOnce = new domMessage()
import {
  Message
} from 'element-ui'
let messageInstance = null;
const rewriteMessage = (options) => {
    if (messageInstance) {
      messageInstance.close()
    }
    messageInstance = Message(options)
  }
  ['error', 'success', 'info', 'warning'].forEach(type => {
    rewriteMessage[type] = options => {
      if (typeof options === 'string') {
        options = {
          message: options
        }
      }
      options.type = type
      return rewriteMessage(options)
    }
  })

import router from '../router/index'
// 创建axios 实例
const service = axios.create({
  // baseURL: process.env.baseUrl, // api的base_url
  // baseURL: "http://192.168.66.18:8200/api",
  // baseURL: "http://192.168.66.9:8081/api",
  // baseURL:"http://jus.newacademic.net/api",
  baseURL: window.location.origin + '/api/',
  timeout: 50000 // 请求超时时间
})

service.interceptors.request.use((config) => {

  // 动态设置请求头
  config.headers.common = {
    Authorization: 'Bearer ' + store.getCookie('token_S')
  }
  // console.log(store.getCookie('token'))
  if (config.method === 'post') {
    config.data = {
      ...config.data,
      t: Date.parse(new Date())
    }
  } else if (config.method === 'get') {
    config.params = {
      ...config.params,
      t: Date.parse(new Date())
    }
  }
  return config
}, (err) => {
  return Promise.reject(err)
})

service.interceptors.response.use((res) => {


  if (res.data.code == 200) {
    return res
  } else if (res.data.code == 1003 || res.data.code == 1002 || res.data.code == 1001) {

    let flag = true
    // console.log(window.location.href)
    if (window.location.href == "http://192.168.44.105:8080/" || window.location.href == "http://jus.newacademic.net/") {
      // Message.error({
      //   type: 'error',
      //   message: res.data.message,
      // });
      messageOnce.error({
        message: res.data.message,
        type: 'error'
      })
    } else {
      store.clearCookie("token");
      store.clearCookie("valid");
      router.push({
        path: "/",
      });
      store.clearCookie("user_id");
      rewriteMessage.error(res.data.message)
      // Message.error({
      //   type: 'error',
      //   message: res.data.message + '！请重新登录'
      // });
      messageOnce.error({
        message: res.data.message + '！请重新登录',
        type: 'error'
      })
      return
    }

    // location.reload();
  } else if (res.data.code == 0) {
    // Message.error({
    //   type: 'error',
    //   message: res.data.message,
    // });
    messageOnce.error({
      message: res.data.message,
      type: 'error'
    })
  } else if (res.data.code == 422) {
    console.log('a')
    messageOnce.error({
      message: res.data.message + '！请稍后再试',
      type: 'error'
    })
    // Message.error({
    //   type: 'error',
    //   message: res.data.message + '！请稍后再试',
    // });
  } else {
    console.log(res)
    if (!res.code) {
      // Message.error({
      //   type: 'error',
      //   message: '未知错误！请稍后再试',
      // });
      messageOnce.error({
        message: '未知错误！请稍后再试',
        type: 'error'
      })
    }

  }
  return res
}, (err) => {
  // console.log(err.response.data)
  // Message.error({
  //   type: 'error',
  //   message: '请求错误！请稍后再试',
  // });
  // return
  return Promise.reject(err)

})



export default service